import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Building2,
  Users2,
  CreditCard,
  Settings2,
  FileText,
  Shield,
  Zap,
  BarChart3,
  Globe,
  Headphones,
  Brain,
  Palette
} from 'lucide-react';

/**
 * Navigation sidebar for the superadmin interface
 */
const SuperAdminNavbar: React.FC = () => {
  const navGroups = [
    {
      title: "Overview",
      items: [
        { path: '/superadmin', icon: LayoutDashboard, label: 'Dashboard' }
      ]
    },
    {
      title: "Platform Management", 
      items: [
        { path: '/superadmin/organizations', icon: Building2, label: 'Organizations' },
        { path: '/superadmin/users', icon: Users2, label: 'Users' },
        { path: '/superadmin/subscription-management', icon: BarChart3, label: 'Subscription Plans' },
        { path: '/superadmin/semantic-analysis', icon: Brain, label: 'AI Semantic Analysis' }
        ,{ path: '/superadmin/operational-tracker', icon: BarChart3, label: 'Operational Tracker' }
      ]
    },
    {
      title: "Stripe Management",
      items: [
        { path: '/superadmin/stripe-plans', icon: Zap, label: 'Plans & Pricing' },
        { path: '/superadmin/customers', icon: Users2, label: 'Customers' },
        { path: '/superadmin/subscriptions', icon: CreditCard, label: 'Subscriptions' },
        { path: '/superadmin/stripe-connect-requests', icon: CreditCard, label: 'Connect Requests' },
        { path: '/superadmin/automation', icon: Settings2, label: 'Automation Rules' },
        { path: '/superadmin/templates', icon: Zap, label: 'Templates' },
        { path: '/superadmin/pricing-validator', icon: Shield, label: 'Pricing Validator' },
        { path: '/superadmin/cta-debug', icon: FileText, label: 'CTA Debugger' }
      ]
    },
    {
      title: "System",
      items: [
        { path: '/superadmin/system', icon: Settings2, label: 'Platform Health' },
        { path: '/superadmin/bizadmin-design-system', icon: Palette, label: 'BizAdmin Design System' }
      ]
    }
  ];
  
  return (
    <div className="hidden md:flex flex-col w-64 bg-gray-900 text-white">
      <div className="p-4 border-b border-gray-800">
        <div className="flex items-center">
          <Shield className="h-6 w-6 mr-2 text-yellow-500" />
          <span className="font-bold">Platform Admin</span>
        </div>
      </div>
      
      <nav className="flex-1 p-4 space-y-6">
        {navGroups.map((group, groupIndex) => (
          <div key={groupIndex}>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
              {group.title}
            </h3>
            <div className="space-y-1">
              {group.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) => `
                    flex items-center px-3 py-2 rounded-md text-sm transition-colors
                    ${isActive 
                      ? 'bg-yellow-600 text-white' 
                      : 'text-gray-300 hover:bg-gray-800 hover:text-white'}
                  `}
                >
                  <item.icon className="h-4 w-4 mr-3" />
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>
      
      <div className="p-4 border-t border-gray-800">
        <div className="flex items-center gap-2 text-sm text-gray-400">
          <Headphones className="h-4 w-4" />
          <span>Support</span>
        </div>
        <p className="text-xs text-gray-500 mt-1">Hivetivity Platform v2.0</p>
      </div>
    </div>
  );
};

export default SuperAdminNavbar; 